const s = {
  name: "ZoomIn",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M15,15v-5h2v5h5v2h-5v5h-2v-5h-5v-2H15z"/>
		<path class="st0" d="M16,0C7.2,0,0,7.2,0,16c0,8.8,7.2,16,16,16c3.3,0,6.4-1,9-2.8L35.8,40l4.2-4.2L29.2,25c1.7-2.6,2.8-5.7,2.8-9
			C32,7.2,24.8,0,16,0z M2,16C2,8.3,8.3,2,16,2c7.7,0,14,6.3,14,14c0,7.7-6.3,14-14,14C8.3,30,2,23.7,2,16z M28,26.6l9.2,9.2
			l-1.4,1.4L26.6,28C27.1,27.6,27.6,27.1,28,26.6z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as ZoomIn
};
